import { setContext } from '@apollo/client/link/context';
import { localStorage, sessionStorage } from '../../storage';

const SESSION_CONTEXT_INFO = 'sessionContext';
const storage =
  process.env.APP_STORE === 'session' ? sessionStorage : localStorage;

const intlLink = setContext((_, { headers }) => {
  const session = JSON.parse(storage.getItem(SESSION_CONTEXT_INFO));
  if (!session) return { headers };

  const intlHeaders = {};
  if (session?.language) intlHeaders['Accept-Language'] = session.language;

  return {
    headers: {
      ...headers,
      ...intlHeaders
    }
  };
});

export default intlLink;
